import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, Check, Compass } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Le due password non coincidono");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian text-cream flex flex-col items-center justify-center p-5" data-testid="reset-password-page">
      <Link to="/admin/login" className="flex items-center gap-2.5 mb-10" data-testid="reset-logo">
        <Compass className="h-6 w-6 text-copper" />
        <span className="font-serif text-xl tracking-[0.18em] uppercase">De Los Cielos</span>
      </Link>
      <div className="w-full max-w-sm card-dark p-8">
        {!token ? (
          <div data-testid="reset-invalid-token">
            <h1 className="font-serif text-2xl">Link non valido</h1>
            <p className="mt-3 text-sm text-cream2">Il link non contiene il codice di reimpostazione. Richiedine uno nuovo dall'accesso.</p>
            <Link to="/admin/password-dimenticata" className="btn-copper w-full mt-7" data-testid="reset-request-again">Richiedi un nuovo link</Link>
          </div>
        ) : done ? (
          <div data-testid="reset-success">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border border-copper text-copper mb-5"><Check className="h-5 w-5" /></span>
            <h1 className="font-serif text-2xl">Password aggiornata.</h1>
            <p className="mt-3 text-sm text-cream2">Ora puoi entrare con la nuova password. Per sicurezza, le sessioni attive sono state disconnesse.</p>
            <Link to="/admin/login" className="btn-copper w-full mt-7" data-testid="reset-go-login">Vai all'accesso</Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="reset-form">
            <h1 className="font-serif text-2xl">Scegli una nuova password</h1>
            <p className="mt-2 text-sm text-cream2">Almeno 8 caratteri. Consigliata una combinazione di lettere, numeri e simboli.</p>
            <div className="mt-6 space-y-4">
              <div>
                <label className="label" htmlFor="r-pass">Nuova password</label>
                <input id="r-pass" type="password" required minLength={8} className="field" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" />
              </div>
              <div>
                <label className="label" htmlFor="r-confirm">Conferma password</label>
                <input id="r-confirm" type="password" required minLength={8} className="field" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm-input" />
              </div>
            </div>
            {error && <p className="mt-4 text-sm text-red-400" data-testid="reset-error">{error}</p>}
            <button type="submit" disabled={busy} className="btn-copper w-full mt-6 disabled:opacity-50" data-testid="reset-submit-btn">
              {busy ? "Salvo…" : "Aggiorna password"}
            </button>
          </form>
        )}
      </div>
      <Link to="/admin/login" className="mt-8 font-mono text-[10px] uppercase tracking-widest text-sand hover:text-copperlight transition-colors flex items-center gap-2" data-testid="reset-back-link">
        <ArrowLeft className="h-3.5 w-3.5" /> Torna all'accesso
      </Link>
    </div>
  );
}
